import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import PostsTableBodyGroup from '../../components/molecules/PostsTableBodyGroup';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  stickyActionsColumn: {
    '& table': {
      border: '1px solid #CCCCCC',
      backgroundColor: '#ffffff'
    },
    '& table th': {
      borderBottom: '2px solid #CCCCCC',
      zIndex: '10 !important',
      borderTop: '1px solid #CCCCCC',
      color: '#000000',
      fontWeight: 'bold',
      backgroundColor: '#ffffff'
    }
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(),
  // state => ({}),
  setPropTypes(propTypes),
  withState('loading', 'updateLoading', false),
  withState('rowsPerPage', 'setRowsPerPage', 20),
  withState('targetRowId', 'setTargetRowId', 0),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    rssItems,
    rowsPerPage, // targetRowId,
    setTargetRowId,
    openDeleteProgress,
    progressOkAction,
    loading,
    resultMessage
  }) => {
    return (
      <div>
        <div
          className={`${classes.scrollTable} ${classes.stickyActionsColumn}`}
          id="scrollTableId"
        >
          <Table>
            <PostsTableBodyGroup
              rssItems={rssItems}
              page={page}
              rowsPerPage={rowsPerPage}
              setTargetRowId={setTargetRowId}
            />
          </Table>
        </div>

        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
